import _ from 'lodash'

import { SHIPPING_ADDRESS_COLLECTION_PREFERENCES } from './constants'

export function isHideShippingAddress(shippingAddressCollectionPreference) {
  return (
    shippingAddressCollectionPreference ===
    SHIPPING_ADDRESS_COLLECTION_PREFERENCES.HIDE
  )
}

export function getAddressSupportedCountries({
  addressBook,
  tokenAddressBook,
} = {}) {
  if (!addressBook && !tokenAddressBook) {
    return []
  } else if (addressBook && addressBook.length) {
    return _.uniq(addressBook.map(address => address.countryCode))
  } else if (tokenAddressBook && tokenAddressBook.length) {
    return _.uniq(tokenAddressBook.map(address => address.country_code))
  }
  return []
}
